import React from "react";

const Videos = () => {
  return (
    <div>
      <h1>This is videos page</h1>
      {/* <iframe
        width='890'
        height='500'
        src='https://www.youtube.com/embed/XKfgdkcIUxw'
        title='YouTube video player'
        frameBorder='0'
        allowFullScreen
      ></iframe> */}
    </div>
  );
};

export default Videos;
